import { render, staticRenderFns } from "./TriageCalculationCriteria.vue?vue&type=template&id=f1240e90"
import script from "./TriageCalculationCriteria.vue?vue&type=script&lang=ts"
export * from "./TriageCalculationCriteria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports